/**
 * @generated SignedSource<<8aa23f68da10552e536c3daad79652dc>>
 * @relayHash 15463b25c103a1583c0618a682f40bda
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 15463b25c103a1583c0618a682f40bda

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Document",
    "kind": "LinkedField",
    "name": "documents",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "folder",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ccnId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "offerType",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectDocumentQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SelectDocumentQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "15463b25c103a1583c0618a682f40bda",
    "metadata": {},
    "name": "SelectDocumentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "d4b07b8987ecaaddd8d716f09494a620";

export default node;
